// src/pages/PageIntrouvable.tsx
//
// Page 404 — ⚙️ SAMSON YAPO, 30/09/2026
//
// ═══ Pourquoi elle existe ════════════════════════════════════════════════
// La route catch-all REDIRIGEAIT vers l'accueil. Deux conséquences :
//
//   • pour le visiteur : une adresse fautive le déposait sur l'accueil sans
//     un mot, comme si de rien n'était — il croyait la page déplacée ;
//   • pour les moteurs : toute URL inventée répondait 200 avec le contenu de
//     l'accueil. Google y voyait autant de pages différentes portant le même
//     contenu, c'est-à-dire du contenu dupliqué à l'infini.
//
// On ne peut pas renvoyer un vrai 404 HTTP depuis une SPA : le serveur a déjà
// répondu 200 avant que React ne sache que la route n'existe pas. La parade
// est `<meta name="robots" content="noindex">`, que les moteurs respectent :
// la page est lue, puis écartée de l'index.
//
// ⚠️ NE REMETTEZ PAS un `<Navigate>` sur la route `*` : cela réintroduirait
// l'indexation de pages fantômes.
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SearchX, Home } from 'lucide-react';

export default function PageIntrouvable() {
  useEffect(() => {
    document.title = 'Page introuvable — 404';

    // Demande explicite de ne pas indexer. Retirée au démontage pour que la
    // balise ne contamine pas la page suivante dans une navigation SPA.
    const balise = document.createElement('meta');
    balise.setAttribute('name', 'robots');
    balise.setAttribute('content', 'noindex, follow');
    document.head.appendChild(balise);

    return () => { balise.remove(); };
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-16">
      <div className="max-w-md text-center">
        <SearchX className="h-12 w-12 text-slate-300 mx-auto mb-4" />
        <p className="text-sm font-semibold text-slate-400 tracking-wide">ERREUR 404</p>
        <h1 className="mt-2 text-2xl font-bold text-slate-800">Cette page n'existe pas</h1>
        <p className="mt-3 text-sm text-slate-600">
          L'adresse saisie ne correspond à aucune page. Elle a peut-être été
          déplacée, ou comporte une faute de frappe.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-slate-800 text-white text-sm font-medium hover:bg-slate-700"
        >
          <Home className="h-4 w-4" />
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}
